// Модели бизнес-объектов и их права согласно RBAC спецификации
export const BUSINESS_MODELS = [
    {
        id: 'customer',
        label: 'Клиенты',
        permissions: {
            view: 'customer.view_customer',
            add: 'customer.add_customer',
            change: 'customer.change_customer',
            delete: 'customer.delete_customer',
            special: [
                { code: 'customer.archive_customer', label: 'Архив' },
                { code: 'customer.assign_responsible_customer', label: 'Ответственный' },
                { code: 'task.create_for_customer', label: 'Задача' },
            ]
        }
    },
    {
        id: 'facility',
        label: 'Объекты',
        permissions: {
            view: 'facility.view_facility',
            add: 'facility.add_facility',
            change: 'facility.change_facility',
            delete: 'facility.delete_facility',
            special: [
                { code: 'facility.archive_facility', label: 'Архив' },
                { code: 'facility.assign_responsible_facility', label: 'Ответственный' },
                { code: 'task.create_for_facility', label: 'Задача' },
            ]
        }
    },
    {
        id: 'contact',
        label: 'Контакты',
        permissions: {
            view: 'contact.view_contact',
            add: 'contact.add_contact',
            change: 'contact.change_contact',
            delete: 'contact.delete_contact',
            special: []
        }
    },
    {
        id: 'contract',
        label: 'Договоры',
        permissions: {
            view: 'contract.view_contract',
            add: 'contract.add_contract',
            change: 'contract.change_contract',
            delete: 'contract.delete_contract',
            special: [
                { code: 'contract.archive_contract', label: 'Архив' },
                { code: 'contract.assign_responsible_contract', label: 'Ответственный' },
                { code: 'task.create_for_contract', label: 'Задача' },
                { code: 'contract.change_status_contract', label: 'Статус' },
            ]
        }
    },
    {
        id: 'work',
        label: 'Работы',
        permissions: {
            view: 'work.view_work',
            add: 'work.add_work',
            change: 'work.change_work',
            delete: 'work.delete_work',
            special: [
                { code: 'work.archive_work', label: 'Архив' },
                { code: 'work.assign_responsible_work', label: 'Ответственный' },
                { code: 'task.create_for_work', label: 'Задача' },
                { code: 'work.change_status_work', label: 'Статус' },
            ]
        }
    },
    {
        id: 'employee',
        label: 'Сотрудники',
        permissions: {
            view: 'employee.view_employeeprofile',
            add: 'employee.add_employeeprofile',
            change: 'employee.change_employeeprofile',
            delete: 'employee.delete_employeeprofile',
            special: [
                { code: 'employee.archive_employeeprofile', label: 'Архив' },
            ]
        }
    },
    {
        id: 'comment',
        label: 'Комментарии',
        permissions: {
            view: 'comment.view_comment',
            add: 'comment.add_comment',
            change: 'comment.change_comment',
            delete: 'comment.delete_comment',
            special: []
        }
    },
    {
        id: 'attachment',
        label: 'Документы',
        permissions: {
            view: 'file.view_attachment',
            add: 'file.add_attachment',
            change: 'file.change_attachment',
            delete: 'file.delete_attachment',
            special: []
        }
    }
];

// Утилита: преобразовать плоский массив permissions в объект для матрицы
export function permissionsArrayToMatrix(permissionsArray = []) {
    const matrix = {};

    BUSINESS_MODELS.forEach(model => {
        matrix[model.id] = {
            view: permissionsArray.includes(model.permissions.view),
            add: permissionsArray.includes(model.permissions.add),
            change: permissionsArray.includes(model.permissions.change),
            delete: permissionsArray.includes(model.permissions.delete),
            special: model.permissions.special
                .filter(sp => permissionsArray.includes(sp.code))
                .map(sp => sp.code)
        };
    });

    return matrix;
}

// Утилита: преобразовать объект матрицы обратно в плоский массив permissions
export function permissionsMatrixToArray(matrix = {}) {
    const permissions = [];

    BUSINESS_MODELS.forEach(model => {
        const modelPerms = matrix[model.id];
        if (!modelPerms) return;

        if (modelPerms.view) permissions.push(model.permissions.view);
        if (modelPerms.add) permissions.push(model.permissions.add);
        if (modelPerms.change) permissions.push(model.permissions.change);
        if (modelPerms.delete) permissions.push(model.permissions.delete);

        if (Array.isArray(modelPerms.special)) {
            permissions.push(...modelPerms.special);
        }
    });

    return permissions;
}

// Утилита: получить все возможные права (для отладки)
export function getAllPermissions() {
    const all = [];

    BUSINESS_MODELS.forEach(model => {
        all.push(model.permissions.view);
        all.push(model.permissions.add);
        all.push(model.permissions.change);
        all.push(model.permissions.delete);
        model.permissions.special.forEach(sp => all.push(sp.code));
    });

    return all;
}
